// A story's summary: a bullet list when it's an official Summary (full views),
// running text otherwise and in compact views (cards clamp to a few lines).
import { plainSummary, summaryBullets } from "../../shared/summaryText.ts";

export function SummaryText({ text, compact = false }: { text: string; compact?: boolean }) {
  const bullets = compact ? null : summaryBullets(text);
  if (!bullets) return <>{plainSummary(text)}</>;
  return (
    <ul className="list-disc space-y-1.5 pl-5 marker:text-ink-soft">
      {bullets.map((b) => <li key={b}>{b}</li>)}
    </ul>
  );
}
